export enum AccountView {
  Home = "Home",
  Users = "Users",
  Projects = "Projects",
  Integrations = "Integrations",
}
